import { gatewayClient } from '../utils/gatewayClient';

export interface FetchSubscriptionsResponse {
  count: number;
  limit: number;
  page: number;
  subscriptions: Array<{
    company_id: string;
    company_name: string;
    created: string;
    employee_email: string;
    employee_first_name: string;
    employee_full_name: string;
    employee_id: string;
    employee_last_name: string;
    excluded_wallet_ids: string[];
    id: string;
    membership_info: {
      dob: string;
      employee_id: string;
      excluded_wallet_ids: string[];
      is_current_member: string;
      is_dna_profile_present: string;
      phone: string;
      pid: string;
      product_id: string;
      sales_tax: number;
      tos: string;
      type: string;
      use_points: boolean;
      vendor_code: string;
      vid: string;
    };
    next_bill_date: string;
    product_id: string;
    product_title: string;
    status: string;
    title: string;
    total_amount: number;
    use_points: boolean;
    vendor_id: string;
    vendor_title: string;
  }>;
}

export function fetchSubscriptions(params: {
  page?: number;
  limit?: number;
  sort?: string;
  status?: string;
  vendor_id?: string;
  product_id?: string;
}) {
  return gatewayClient.get<FetchSubscriptionsResponse>(
    '/api/v2/subscriptions',
    {
      params,
    }
  );
}

export function fetchSubscriptionById(id: string) {
  return gatewayClient.get(`/api/v2/subscriptions/${id}`);
}

export function cancelSubscription(id: string) {
  return gatewayClient.put(`/api/v2/subscriptions/${id}/cancel`);
}
